module.exports = __webpack_public_path__ + "static/media/jochananbax.ae515454.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jochananbax.webp
// module id = 293
// module chunks = 0